export default "__VITE_ASSET__IdDUA1K0__"